import React, { useEffect, useState } from "react";
import Logo from "../components/Logo";
import { useDispatch, useSelector } from "react-redux";
import FourButtonsTwo from "../components/FourButtonsTwo";
import moment from "moment";
import {
  addHandOver,
  fetchSingleHandover,
  getCompanydata,
  signOut,
} from "../store/adminSlice";
import escapeHtml from "../functions/Validator";
import Swal from "sweetalert2";
import { adminActions } from "../store/adminSlice";
import { useNavigate } from "react-router-dom";
import URL from "../functions/URLString";
import HeaderScaff from "../components/HeaderScaff";
import { useMediaQuery } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Sidebar from "../components/Sidebar";

function ViewForm() {
  const isNonMobile = useMediaQuery("(min-width: 768px)");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [needed, setNeeded] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const stateSwalAlert = useSelector((state) => state.admin.swalAlert);
  const queryParameters = new URLSearchParams(window.location.search);
  const companyDetails = useSelector((state) => state.admin.companyDetails);
  const handOverData = useSelector((state) => state.admin.handOverData);
  const id = queryParameters.get("id");
  const type = queryParameters.get("type");

  const adminID = useSelector((state) => state.admin._id);
  const [data, setData] = useState({
    customerID: "",
    clientName: "",
    address: "",
    postcode: "",
    dateOfScoffolldingCompletion: "",
    time: "",
    descriptionHandover: "",
    drawingNo: "",
    MaximumLoading: "",
    methodOfTyping: "",
    tiesBeenTested: "",
    methodOfCladding: "",
    handover: "",
    detailsNessesary: "",
    scaffoldingContractor: "",
    scaffolderEmail: "",
    adminID: adminID,
  });
  const statesignOut = useSelector((state) => state.admin.signOut);
  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [statesignOut]);
  const onChangeDate = (e) => {
    const newDate = moment(new Date(e.target.value)).format("YYYY-MM-DD");
    setData({ ...data, dateOfScoffolldingCompletion: newDate });
    // setData({ ...data, customerID: stateSingleJob.customer._id })
  };

  useEffect(() => {
    if (stateSwalAlert === "handoverAdded") {
      Swal.fire({
        icon: "success",
        title: "Saved",
        confirmButtonColor: "#60c088",
      }).then(() => {
        dispatch(adminActions.removeSwalAlert());
        navigate("/liveprojects");
      });
    }
  }, [stateSwalAlert]);
  useEffect(() => {
    setData(handOverData);
  }, [companyDetails, handOverData]);
  useEffect(() => {
    dispatch(getCompanydata(adminID));
    setData({
      ...data,
      scaffoldingContractor: companyDetails.customerOrCompanyName,
    });
    dispatch(fetchSingleHandover({ _id: id, type: type, adminID: adminID }));
  }, []);

  return (
    <div className="w-full h-full">
      <HeaderScaff setSidebarOpen={setSidebarOpen} />
      <div className={`${sidebarOpen ? "" : isNonMobile ? "" : "flex-col"} 'w-full flex h-auto p-2 sm:p-6'`}>
        <div className={`${sidebarOpen ? isNonMobile ? "basis-1/5" : "flex justify-center w-full" : "hidden"} "w-full h-full"`}>
          <Sidebar setSidebarOpen={setSidebarOpen} needed={needed} isNonMobile={isNonMobile} />
        </div>

        <div onClick={() => setSidebarOpen(true)} className={`${sidebarOpen ? isNonMobile ? "hidden" : "hidden" : isNonMobile ? "flex w-12 mt-4" : "flex border-2 border-x-0 bg-gray-100/50 mt-2 -mb-1 w-full items-center justify-center"} h-fit`}>
          <div className={`${sidebarOpen ? isNonMobile ? "" : "" : isNonMobile ? "" : "hidden"}`}>
            <IconButton onClick={() => setSidebarOpen(true)}>
              <ArrowForwardIosIcon />
            </IconButton>
          </div>
          <div className={`${sidebarOpen ? isNonMobile ? "hidden" : "hidden" : isNonMobile ? "hidden" : "flex"}`}>
            <p className="text-gray-500 text-xs py-[2px]">Sidebar</p>
          </div>
        </div>

        <div className={`${sidebarOpen ? isNonMobile ? "lg:basis-3/4 w-full" : "hidden" : isNonMobile ? "w-full" : "hidden"} " "`}>
          <div className="w-full flex flex-col lg:flex-row h-fit">
            <div className="flex flex-col basis-1 lg:basis-1/2 w-full px-0 sm:px-6 xxl:mt-4">
              <div className="flex justify-between items-center mb-4">
                <div>
                  <p className="text-base xxl:text-2xl text-slate-400">Scaffolding Handover</p>
                </div>
                <button
                  id="abw"
                  className="h-8 w-24 xxl:w-32 xxl:h-10 xxl:text-xl text-center rounded-md flex items-center justify-center text-white cursor-pointer bg-lightgreen hover:bg-darkgreen"
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
              </div>
              <div className="flex flex-col w-full mt-1">
                <p className="px-1 pl-0 font-semibold text-[12px] xxl:text-base">
                  Client name
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.clientName}
                  onChange={(e) =>
                    setData({ ...data, clientName: escapeHtml(e.target.value) })
                  }
                  required
                />

                <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                  Address
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.address}
                  onChange={(e) =>
                    setData({ ...data, address: escapeHtml(e.target.value) })
                  }
                  required
                />
                <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                  Post code
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.postcode}
                  onChange={(e) =>
                    setData({ ...data, clientName: escapeHtml(e.target.value) })
                  }
                  required
                />
                <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                  Date scaffolding Completion
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="date"
                  value={data.dateOfScoffolldingCompletion}
                  onChange={onChangeDate}
                  required
                />
                <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                  Time
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.time}
                  onChange={(e) =>
                    setData({ ...data, time: escapeHtml(e.target.value) })
                  }
                  required
                />

                <p className="px-1 my-2 pl-0 xxl:pt-2 font-semibold text-sm xxl:text-xl">
                  Scaffold specification
                </p>

                <p className="px-1 xxl:pt-1 pl-0 font-normal text-[11px] xxl:text-base w-11/12">
                  In accordance with The working at height Regulations 2005 this
                  scaffold must be inspected by the User and a record maintained
                  of the inspections as follows; Before being taken into use for
                  the first time After substantial addition, dismantling or
                  other alterations After any event likely to have affected its
                  strength or stability At regular intervals not exceeding 7
                  days
                </p>

                <p className="px-1 pl-0 font-semibold xxl:my-4 text-[12px] xxl:text-base my-2">
                  The inside boards only take a loading limit of 0.75kn/m2
                </p>

                <p className="px-1 pl-0 font-semibold text-[12px] xxl:text-base">
                  Description of section handed over
                </p>
                <textarea
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  id="w3review"
                  name="w3review"
                  rows="3"
                  cols="50"
                  value={data.descriptionHandover}
                  onChange={(e) =>
                    setData({
                      ...data,
                      descriptionHandover: escapeHtml(e.target.value),
                    })
                  }
                />
                <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                  Drawing No/TG20:21 compliance sheet ref:
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.drawingNo}
                  onChange={(e) =>
                    setData({ ...data, drawingNo: escapeHtml(e.target.value) })
                  }
                  required
                />
                <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                  Maximum loading
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.MaximumLoading}
                  onChange={(e) =>
                    setData({
                      ...data,
                      MaximumLoading: escapeHtml(e.target.value),
                    })
                  }
                  required
                />
              </div>
            </div>

            <div className="basis-1 lg:basis-1/2 flex flex-col w-full">
              <div className="flex flex-col w-full mt-1">
                <p className="px-1 pl-0 font-semibold text-[12px] xxl:text-base">
                  Method of tying
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.methodOfTyping}
                  onChange={(e) =>
                    setData({
                      ...data,
                      methodOfTyping: escapeHtml(e.target.value),
                    })
                  }
                  required
                />
                <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                  Have the ties been tested?
                </p>
                <select
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  value={data.tiesBeenTested}
                  onChange={(e) =>
                    setData({
                      ...data,
                      tiesBeenTested: escapeHtml(e.target.value),
                    })
                  }
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                  Method of cladding
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.methodOfCladding}
                  onChange={(e) =>
                    setData({
                      ...data,
                      methodOfCladding: escapeHtml(e.target.value),
                    })
                  }
                  required
                />

                <p className="px-1 xxl:mt-4 mt-2 mb-1 pl-0 font-semibold text-sm xxl:text-xl">
                  Handover
                </p>

                <p className="px-1  pl-0 font-normal text-[11px] xxl:text-base w-11/12">
                  The scaffolding as described above has now been completed in
                  accordance with client requirements. It is structurally sound
                  and should only be used, cladded and loaded in accordance with
                  this handover certificate.
                </p>

                <p className="px-1 pt-1 xxl:my-4 pl-0 font-normal text-[11px] xxl:text-base w-11/12">
                  Have the requirements of the work at heights regulations 2005
                  and any other relevant legislation and NASC guidance such as
                  SG4 and TG20:21 been compiled with?
                </p>

                <select
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  value={data.handover}
                  onChange={(e) =>
                    setData({ ...data, handover: escapeHtml(e.target.value) })
                  }
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <p className="px-1 pl-0 font-semibold text-[12px] xxl:text-base mt-2">
                  Details of any further action considered necessary:
                </p>
                <textarea
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  id="w3review"
                  name="w3review"
                  rows="3"
                  cols="50"
                  value={data.detailsNessesary}
                  onChange={(e) =>
                    setData({
                      ...data,
                      detailsNessesary: escapeHtml(e.target.value),
                    })
                  }
                />
                <p className="px-1 mt-2 xxl:mt-4 mb-1 pl-0 font-semibold text-sm xxl:text-xl">
                  Acceptance
                </p>

                <p className="px-1 xxl:mb-4 pl-0 font-normal text-[11px] xxl:text-base w-11/12">
                  We accept that the scaffold must be inspected by a competent
                  person at intervals not exceeding seven days and after any
                  event that may affect its adequacy. We (the client) will not
                  modify the scaffold without authorisation and the scaffold
                  will be used within the parameters set out within this
                  document.
                </p>

                <p className="px-1 pl-0 xxl:mb-4 font-semibold text-[12px] xxl:text-base my-1">
                  Acceptance on behalf of Scaffold firm
                </p>

                <p className="px-1 pl-0 font-semibold text-[12px] xxl:text-base">
                  Name of Company
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  value={data.scaffoldingContractor}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setData({
                      ...data,
                      scaffoldingContractor: escapeHtml(e.target.value),
                    })
                  }
                  required
                />
                <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                  Name of Scaffolder
                </p>
                <input
                  className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.scaffolderEmail}
                  onChange={(e) =>
                    setData({
                      ...data,
                      scaffolderEmail: escapeHtml(e.target.value),
                    })
                  }
                  required
                />
              </div>
            </div>
          </div>
          {data.Images && data.Images.length > 0 && (
          <div className="grid  sm:grid-cols-3 md:grid-cols-4  lg:grid-cols-5 xxl:grid-cols-5 mt-4">
            <div className="mx-2 my-2 flex items-center justify-center">
              <img
                className="mt-2 object-contain"
                src={`${URL}/uploads/${data.Images}`}
                key={data.Images}
                alt="addJobPhoto"
              />
            </div>
          </div>
          )}
        </div>

        {!isNonMobile && !sidebarOpen && (
          <div className="w-full pb-20">
            <div className="w-full flex flex-col h-fit p-4">
              <div className="flex flex-col w-full">
                <p className="text-base text-slate-400">View Form</p>
                <p className="text-xs font-semibold">View form details below</p>
                
                <div className="flex flex-col w-full mt-2">
                  <p className="px-1 pl-0 font-semibold text-[12px] xxl:text-base">
                    Client name
                  </p>
                  <input
                    className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                    type="text"
                    onWheel={(e) => e.target.blur()}
                    value={data.clientName}
                    onChange={(e) =>
                      setData({ ...data, clientName: escapeHtml(e.target.value) })
                    }
                    required
                  />

                  <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                    Address
                  </p>
                  <input
                    className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                    type="text"
                    onWheel={(e) => e.target.blur()}
                    value={data.address}
                    onChange={(e) =>
                      setData({ ...data, address: escapeHtml(e.target.value) })
                    }
                    required
                  />
                  <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                    Post code
                  </p>
                  <input
                    className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                    type="text"
                    onWheel={(e) => e.target.blur()}
                    value={data.postcode}
                    onChange={(e) =>
                      setData({ ...data, clientName: escapeHtml(e.target.value) })
                    }
                    required
                  />
                  <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                    Date scaffolding Completion
                  </p>
                  <input
                    className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                    type="date"
                    value={data.dateOfScoffolldingCompletion}
                    onChange={onChangeDate}
                    required
                  />
                  <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                    Time
                  </p>
                  <input
                    className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                    type="text"
                    onWheel={(e) => e.target.blur()}
                    value={data.time}
                    onChange={(e) =>
                      setData({ ...data, time: escapeHtml(e.target.value) })
                    }
                    required
                  />

                  <p className="px-1 my-2 pl-0 xxl:pt-2 font-semibold text-sm xxl:text-xl">
                    Scaffold specification
                  </p>

                  <p className="px-1 xxl:pt-1 pl-0 font-normal text-[11px] xxl:text-base w-11/12">
                    In accordance with The working at height Regulations 2005 this
                    scaffold must be inspected by the User and a record maintained
                    of the inspections as follows; Before being taken into use for
                    the first time After substantial addition, dismantling or
                    other alterations After any event likely to have affected its
                    strength or stability At regular intervals not exceeding 7
                    days
                  </p>

                  <p className="px-1 pl-0 font-semibold xxl:my-4 text-[12px] xxl:text-base my-2">
                    The inside boards only take a loading limit of 0.75kn/m2
                  </p>

                  <p className="px-1 pl-0 font-semibold text-[12px] xxl:text-base">
                    Description of section handed over
                  </p>
                  <textarea
                    className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                    id="w3review"
                    name="w3review"
                    rows="3"
                    cols="50"
                    value={data.descriptionHandover}
                    onChange={(e) =>
                      setData({
                        ...data,
                        descriptionHandover: escapeHtml(e.target.value),
                      })
                    }
                  />
                  <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                    Drawing No/TG20:21 compliance sheet ref:
                  </p>
                  <input
                    className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                    type="text"
                    onWheel={(e) => e.target.blur()}
                    value={data.drawingNo}
                    onChange={(e) =>
                      setData({ ...data, drawingNo: escapeHtml(e.target.value) })
                    }
                    required
                  />
                  <p className="px-1 pt-2 pl-0 font-semibold text-[12px] xxl:text-base">
                    Maximum loading
                  </p>
                  <input
                    className="bg-gray-200  opacity-50 px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20"
                    type="text"
                    onWheel={(e) => e.target.blur()}
                    value={data.MaximumLoading}
                    onChange={(e) =>
                      setData({
                        ...data,
                        MaximumLoading: escapeHtml(e.target.value),
                      })
                    }
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewForm;
